
import { useNavigate } from "react-router-dom";
import { Box, Grid, IconButton, Typography } from "@mui/material";
import { iconos } from "../../data";







export const LayoutCrearDoc = ({ children, titulo, subtitulo=null, funcion, add=true, pt=0, px=0, pb=0 }) => {


    const navigate = useNavigate();


    return (

        <Box sx={{ minHeight:'100vh', width:'100%', display:'flex', flexDirection:'column', overflow:'hidden', pt:pt, px:px, pb:pb }}>
            <Box sx={{ position:'sticky', top:0, zIndex:10 }}>
                <Grid container direction="row" alignItems="center"sx={{ gap: 2 }}>
                    <Box flex={1} />
                
                    <Typography variant="h2" sx={{fontSize:{ xs:"1rem", sm:"1.2rem", md:"1.7rem" }, fontWeight:600, textAlign:'center'}}>
                        {titulo}
                    </Typography>
                
                    <Box flex={1} sx={{ display:'flex', justifyContent:'flex-end' }}>
                        {(add) 
                        ?   <IconButton onClick={funcion} sx={{ color:'#fff', backgroundColor:'secondary.main' }}>
                                {iconos['plus']}
                            </IconButton>
                        :   <IconButton onClick={() => navigate(-1)} sx={{ color:'#fff', backgroundColor:'primary.main' }}>
                                {iconos['back']}
                            </IconButton>
                        }
                    </Box>
                </Grid>

                {subtitulo && (
                <Grid container justifyContent='center'>
                    <Typography sx={{ color:'#757575', fontSize:'1rem', fontWeight:300, letterSpacing:'0.5px', textAlign:'center' }}>
                        { subtitulo }
                    </Typography>
                </Grid>
            )}
            </Box>


            <Box sx={{ flex:1, overflow:'auto' }}>
                <Grid container sx={{ width:'100%', minHeight:'100%' }}> {children} </Grid>
            </Box>
        </Box>

    )
}
